import "./index.less";
import template from "./index.html";

function controller() {}

export default angular
	.module("vesl.screens.public.privacy", [])
	.component("privacy", {
		template,
		controller
	}).name;
